import React, { useState, useReducer } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import { CashRegisters, DatePeriod, filterReducer } from '../filterFragments'
import { Form, Select } from 'components/forms'
import { DateIntervalForm } from 'components/shared/DateIntervalForm'
import { ContentBlock, ExpandableBlocks } from 'components/ContentBlock'
import { useQuery } from 'components/graphql'
import { getOrderGroups } from '../../gql'
import { Modal } from 'components/Modal'
import Button from 'components/Button'
import Divider from 'components/Divider'
import { Row, Col } from 'react-flexbox-grid'

import { CardsRow, CardCol } from '../filterFragments/styled'
import { FormRow, FormCol } from 'style/styled'
import { listCashRegisters } from 'gql/query'
import ProfileSettings from 'components/ProfileSettings/ProfileSettings'

const Filter = ({ onFilter, onFilterShops, splittedPeriodRef }) => {
	const { data } = useQuery(listCashRegisters, { fetchPolicy: 'cache-first' })
	const defaultFilter = {
		from: moment().utc().startOf('day').toISOString(),
		to: moment().utc().endOf('day').toISOString(),
		cashRegistersId: data?.listCashRegisters?.map(({ id }) => id) || [],
	}
	const [filter, dispatchFilter] = useReducer(filterReducer, defaultFilter)
	const [showDateModal, setShowDateModal] = useState()
	const { data: orderGroups, queryField } = useQuery(getOrderGroups)
	const [t] = useTranslation()

	const { from, to, cashRegistersId, orderType } = filter
	const dateLabel = t('statistic_section.strings.date')
	const isPeriod = moment(filter?.toDateTime).diff(moment(filter?.from), 'days') >= 1

	const handleFilter = () => {
		onFilter(filter)
	}
	const handleFilterShops = () => {
		onFilterShops(filter)
	}
	const handleSetProfileSettings = settings => {
		const filterToSet = settings ? settings : defaultFilter
		dispatchFilter({
			type: 'hydrateFromSaved',
			value: filterToSet
		})
	}

	return(
		<>
			<Row>
				<Col xs={12} style={{ marginLeft: -20 }}>
					<ProfileSettings filters={filter} onUpdateFilters={handleSetProfileSettings} nameLocalStorage={'erpStatisticsProfiles'} />
				</Col>
			</Row>
			<FormRow>
				<FormCol xs {...!isPeriod && { narrow: true }}>
					<DatePeriod
						value={{ fromDateTime: from, toDateTime: to }}
						onChange={value => dispatchFilter({ value, type: 'dateTime' })}
						label={dateLabel}
						labelPeriod={{
							from: `${dateLabel} ${t('common.strings.from').toLowerCase()}`,
							to: `${dateLabel} ${t('common.strings.to').toLowerCase()}`
						}}
					/>
				</FormCol>
				<FormCol xs>
					<Select
						noForm
						value={orderType || '0'}
						label={t('statistic_section.strings.select_data')}
						options={orderGroups?.[queryField]?.filterOrderGroups || []}
						valueField='value'
						labelField='name'
						onChange={({ value }) => dispatchFilter({ value: value === '0' ? null : value, type: 'orderType' })}
					/>
				</FormCol>
			</FormRow>
			<div>
				<ExpandableBlocks nested>
					<ContentBlock startExpanded label={t('common.buttons.filter')}>
						<CardsRow>
							<CardCol>
								<CashRegisters
									value={cashRegistersId}
									onChange={value => dispatchFilter({ value, type: 'cashRegistersId' })}
								/>
							</CardCol>
						</CardsRow>
					</ContentBlock>
				</ExpandableBlocks>
			</div>
			<Divider />
			<Button text={t('statistic_section.strings.calculate_erp_data')} onClick={handleFilter} />
			<Button text={t('statistic_section.strings.calculate_shop_data')} onClick={handleFilterShops} />
			{showDateModal &&
				<Modal unmount={() => setShowDateModal(false)} label={t('common.strings.date_period')} width={500}>
					<Form
						initialValues={{ period: { from, to } }}
						onSubmit={({ period }) => {
							setShowDateModal(false)
							dispatchFilter({ value: period, type: 'dateTime' })
						}}
					>
						<DateIntervalForm />
						<Divider />
						<Button type='submit' text='anwenden' />
					</Form>
				</Modal>
			}
		</>
	)
}

export default Filter
